module.exports = __webpack_public_path__ + "static/media/lightGreenCircle.23b5f297.svg";